var render, staticRenderFns
import script from "./inventoryList.vue?vue&type=script&lang=js&"
export * from "./inventoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a7d483",
  null
  
)

export default component.exports